var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "row" },
    [
      _c("b-loading", {
        attrs: {
          "is-full-page": _vm.isFullPage,
          active: _vm.isLoading,
          "can-cancel": true
        },
        on: {
          "update:active": function($event) {
            _vm.isLoading = $event
          }
        }
      }),
      _vm._v(" "),
      _c(
        "div",
        {
          staticClass: "sidebar sidebar-fixed bg-white",
          attrs: { id: "sidebarMenu" }
        },
        [
          _c("div", { staticClass: "sidebar-header" }, [
            _c("h5", [_vm._v(" ")]),
            _vm._v(" "),
            _c(
              "a",
              { attrs: { href: "", id: "sidebarMenuClose" } },
              [
                _c("feather", {
                  staticClass:
                    "wd-15 hd-15 mg-r-5 valign-middle-f svg_overflow",
                  attrs: { type: "x" }
                })
              ],
              1
            )
          ]),
          _vm._v(" "),
          _c("div", { staticClass: "sidebar-body" }, [
            _vm.properties.uid
              ? _c(
                  "div",
                  [
                    _vm._l(_vm.inputSearchForms, function(form, i) {
                      return form.division === "C"
                        ? _c("ul", { staticClass: "sidebar-nav" }, [
                            i === 0
                              ? _c(
                                  "li",
                                  { staticClass: "nav-label mg-b-10-f" },
                                  [_vm._v(" ")]
                                )
                              : _vm._e(),
                            _vm._v(" "),
                            _c("div", { staticClass: "form-group" }, [
                              _c(
                                "label",
                                {
                                  staticClass: "has-text-weight-semibold",
                                  attrs: { for: form.id }
                                },
                                [
                                  _vm._v(_vm._s(form.name) + " "),
                                  form.division === "C" && form.attr
                                    ? _c(
                                        "span",
                                        {
                                          staticClass:
                                            "tx-danger has-text-weight-semibold"
                                        },
                                        [_vm._v("*")]
                                      )
                                    : _vm._e()
                                ]
                              ),
                              _vm._v(" "),
                              _c("input", {
                                directives: [
                                  {
                                    name: "model",
                                    rawName: "v-model.lazy",
                                    value: _vm.headerData[form.id],
                                    expression: "headerData[form.id]",
                                    modifiers: { lazy: true }
                                  }
                                ],
                                staticClass: "form-control",
                                attrs: {
                                  type: "email",
                                  name: form.id,
                                  id: form.id,
                                  placeholder: form.name
                                },
                                domProps: { value: _vm.headerData[form.id] },
                                on: {
                                  change: function($event) {
                                    return _vm.$set(
                                      _vm.headerData,
                                      form.id,
                                      $event.target.value
                                    )
                                  }
                                }
                              })
                            ])
                          ])
                        : form.division === "O"
                        ? _c("ul", { staticClass: "sidebar-nav" }, [
                            i === 0
                              ? _c(
                                  "li",
                                  { staticClass: "nav-label mg-b-10-f" },
                                  [_vm._v(" ")]
                                )
                              : _vm._e(),
                            _vm._v(" "),
                            _c("div", { staticClass: "form-group" }, [
                              _c(
                                "label",
                                {
                                  staticClass:
                                    "d-block has-text-weight-semibold",
                                  attrs: { for: "formGroupExampleInput" }
                                },
                                [_vm._v(_vm._s(form.name))]
                              ),
                              _vm._v(" "),
                              form.value.length > 0
                                ? _c(
                                    "p",
                                    { staticClass: "mg-b-0 text-left" },
                                    _vm._l(form.value, function(form1, i) {
                                      return form1.codeCode ==
                                        _vm.headerData[form.id]
                                        ? _c("span", [
                                            _vm._v(_vm._s(form1.codeName))
                                          ])
                                        : _vm._e()
                                    }),
                                    0
                                  )
                                : _c("p", { staticClass: "mg-b-0 text-left" }, [
                                    _vm._v(_vm._s(_vm.headerData[form.id]))
                                  ])
                            ])
                          ])
                        : _vm._e()
                    }),
                    _vm._v(" "),
                    _vm._l(_vm.checkboxSearchForms, function(form, i) {
                      return _c("ul", { staticClass: "sidebar-nav" }, [
                        _c(
                          "div",
                          { staticClass: "form-group" },
                          [
                            _c(
                              "label",
                              {
                                staticClass:
                                  " d-block has-text-weight-semibold",
                                attrs: { for: "formGroupExampleInput" }
                              },
                              [
                                _vm._v(_vm._s(form.name) + " "),
                                form.division === "C" && form.attr
                                  ? _c(
                                      "span",
                                      {
                                        staticClass:
                                          "tx-danger has-text-weight-semibold"
                                      },
                                      [_vm._v("*")]
                                    )
                                  : _vm._e()
                              ]
                            ),
                            _vm._v(" "),
                            _vm._l(form.value, function(form1, i) {
                              return _c(
                                "div",
                                {
                                  staticClass:
                                    "ml-2 custom-control custom-radio mb-1"
                                },
                                [
                                  _c("input", {
                                    directives: [
                                      {
                                        name: "model",
                                        rawName: "v-model",
                                        value: _vm.headerData[form.id],
                                        expression: "headerData[form.id]"
                                      }
                                    ],
                                    staticClass: "custom-control-input",
                                    attrs: {
                                      type: "radio",
                                      id: form1.codeCode,
                                      name: form.id
                                    },
                                    domProps: {
                                      value: form1.codeCode,
                                      checked:
                                        form1.codeCode ==
                                        _vm.headerData[form.id],
                                      checked: _vm._q(
                                        _vm.headerData[form.id],
                                        form1.codeCode
                                      )
                                    },
                                    on: {
                                      change: function($event) {
                                        return _vm.$set(
                                          _vm.headerData,
                                          form.id,
                                          form1.codeCode
                                        )
                                      }
                                    }
                                  }),
                                  _vm._v(" "),
                                  _c(
                                    "label",
                                    {
                                      staticClass: "custom-control-label",
                                      attrs: { for: form1.codeCode }
                                    },
                                    [_vm._v(_vm._s(form1.codeName))]
                                  )
                                ]
                              )
                            })
                          ],
                          2
                        )
                      ])
                    }),
                    _vm._v(" "),
                    _vm._l(_vm.dateSearchForms, function(form, i) {
                      return _c("ul", { staticClass: "sidebar-nav" }, [
                        _c("div", { staticClass: "form-group" }, [
                          _c(
                            "label",
                            {
                              staticClass: "d-block has-text-weight-semibold",
                              attrs: { for: "formGroupExampleInput" }
                            },
                            [
                              _vm._v(_vm._s(form.name) + " "),
                              form.division === "C" && form.attr
                                ? _c(
                                    "span",
                                    {
                                      staticClass:
                                        "tx-danger has-text-weight-semibold"
                                    },
                                    [_vm._v("*")]
                                  )
                                : _vm._e()
                            ]
                          ),
                          _vm._v(" "),
                          _c("p", { staticClass: "mg-b-0 text-left" }, [
                            _vm._v(_vm._s(_vm.headerData[form.id]))
                          ])
                        ])
                      ])
                    })
                  ],
                  2
                )
              : _c(
                  "div",
                  [
                    _vm._l(_vm.inputSearchForms, function(form, i) {
                      return form.division === "C"
                        ? _c("ul", { staticClass: "sidebar-nav" }, [
                            i === 0
                              ? _c(
                                  "li",
                                  { staticClass: "nav-label mg-b-10-f" },
                                  [_vm._v(" ")]
                                )
                              : _vm._e(),
                            _vm._v(" "),
                            _c("div", { staticClass: "form-group" }, [
                              _c(
                                "label",
                                {
                                  staticClass: "has-text-weight-semibold",
                                  attrs: { for: form.id }
                                },
                                [
                                  _vm._v(_vm._s(form.name) + " "),
                                  form.division === "C" && form.attr
                                    ? _c(
                                        "span",
                                        {
                                          staticClass:
                                            "tx-danger has-text-weight-semibold"
                                        },
                                        [_vm._v("*")]
                                      )
                                    : _vm._e()
                                ]
                              ),
                              _vm._v(" "),
                              _c("input", {
                                directives: [
                                  {
                                    name: "model",
                                    rawName: "v-model.lazy",
                                    value: _vm.headerData[form.id],
                                    expression: "headerData[form.id]",
                                    modifiers: { lazy: true }
                                  }
                                ],
                                staticClass: "form-control",
                                attrs: {
                                  type: "email",
                                  name: form.id,
                                  id: form.id,
                                  placeholder: form.name
                                },
                                domProps: { value: _vm.headerData[form.id] },
                                on: {
                                  change: function($event) {
                                    return _vm.$set(
                                      _vm.headerData,
                                      form.id,
                                      $event.target.value
                                    )
                                  }
                                }
                              })
                            ])
                          ])
                        : form.division === "O"
                        ? _c("ul", { staticClass: "sidebar-nav" }, [
                            i === 0
                              ? _c(
                                  "li",
                                  { staticClass: "nav-label mg-b-10-f" },
                                  [_vm._v(" ")]
                                )
                              : _vm._e(),
                            _vm._v(" "),
                            _c("div", { staticClass: "form-group" }, [
                              _c(
                                "label",
                                {
                                  staticClass:
                                    "d-block has-text-weight-semibold",
                                  attrs: { for: "formGroupExampleInput" }
                                },
                                [_vm._v(_vm._s(form.name))]
                              ),
                              _vm._v(" "),
                              form.value.length > 0
                                ? _c(
                                    "p",
                                    { staticClass: "mg-b-0 text-left" },
                                    _vm._l(form.value, function(form1, i) {
                                      return form1.codeCode ==
                                        _vm.headerData[form.id]
                                        ? _c("span", [
                                            _vm._v(_vm._s(form1.codeName))
                                          ])
                                        : _vm._e()
                                    }),
                                    0
                                  )
                                : _c("p", { staticClass: "mg-b-0 text-left" }, [
                                    _vm._v(_vm._s(_vm.headerData[form.id]))
                                  ])
                            ])
                          ])
                        : _vm._e()
                    }),
                    _vm._v(" "),
                    _vm._l(_vm.checkboxSearchForms, function(form, i) {
                      return _c("ul", { staticClass: "sidebar-nav" }, [
                        _c(
                          "div",
                          { staticClass: "form-group" },
                          [
                            _c(
                              "label",
                              {
                                staticClass:
                                  " d-block has-text-weight-semibold",
                                attrs: { for: "formGroupExampleInput" }
                              },
                              [
                                _vm._v(_vm._s(form.name) + " "),
                                form.division === "C" && form.attr
                                  ? _c(
                                      "span",
                                      {
                                        staticClass:
                                          "tx-danger has-text-weight-semibold"
                                      },
                                      [_vm._v("*")]
                                    )
                                  : _vm._e()
                              ]
                            ),
                            _vm._v(" "),
                            _vm._l(form.value, function(form1, i) {
                              return _c(
                                "div",
                                {
                                  staticClass:
                                    "ml-2 custom-control custom-radio mb-1"
                                },
                                [
                                  _c("input", {
                                    directives: [
                                      {
                                        name: "model",
                                        rawName: "v-model",
                                        value: _vm.headerData[form.id],
                                        expression: "headerData[form.id]"
                                      }
                                    ],
                                    staticClass: "custom-control-input",
                                    attrs: {
                                      type: "radio",
                                      id: form1.codeCode,
                                      name: form.id
                                    },
                                    domProps: {
                                      value: form1.codeCode,
                                      checked:
                                        form1.codeCode ==
                                        _vm.headerData[form.id],
                                      checked: _vm._q(
                                        _vm.headerData[form.id],
                                        form1.codeCode
                                      )
                                    },
                                    on: {
                                      change: function($event) {
                                        return _vm.$set(
                                          _vm.headerData,
                                          form.id,
                                          form1.codeCode
                                        )
                                      }
                                    }
                                  }),
                                  _vm._v(" "),
                                  _c(
                                    "label",
                                    {
                                      staticClass: "custom-control-label",
                                      attrs: { for: form1.codeCode }
                                    },
                                    [_vm._v(_vm._s(form1.codeName))]
                                  )
                                ]
                              )
                            })
                          ],
                          2
                        )
                      ])
                    }),
                    _vm._v(" "),
                    _vm._l(_vm.dateSearchForms, function(form, i) {
                      return form.division === "C"
                        ? _c("ul", { staticClass: "sidebar-nav" }, [
                            i === 0
                              ? _c(
                                  "li",
                                  { staticClass: "nav-label mg-b-10-f" },
                                  [_vm._v(" ")]
                                )
                              : _vm._e(),
                            _vm._v(" "),
                            _c(
                              "div",
                              { staticClass: "form-group" },
                              [
                                _c(
                                  "label",
                                  {
                                    staticClass: "has-text-weight-semibold",
                                    attrs: { for: form.id }
                                  },
                                  [
                                    _vm._v(_vm._s(form.name) + " "),
                                    form.division === "C" && form.attr
                                      ? _c(
                                          "span",
                                          {
                                            staticClass:
                                              "tx-danger has-text-weight-semibold"
                                          },
                                          [_vm._v("*")]
                                        )
                                      : _vm._e()
                                  ]
                                ),
                                _vm._v(" "),
                                _c("date-picker", {
                                  staticClass: "form-control",
                                  attrs: {
                                    config: _vm.datePickerOptions,
                                    autocomplete: "off",
                                    placeholder: form.name,
                                    id: form.id,
                                    "aria-label": "Search",
                                    ignoreReadonly: ""
                                  },
                                  model: {
                                    value: _vm.headerData[form.id],
                                    callback: function($$v) {
                                      _vm.$set(_vm.headerData, form.id, $$v)
                                    },
                                    expression: "headerData[form.id]"
                                  }
                                })
                              ],
                              1
                            )
                          ])
                        : _vm._e()
                    })
                  ],
                  2
                )
          ])
        ]
      ),
      _vm._v(" "),
      _c(
        "div",
        { staticClass: "content content-components pd-b-0-f overflow-hidden" },
        [
          _c("div", { staticClass: "pd-x-0 pd-lg-x-10 pd-xl-x-0" }, [
            _c(
              "div",
              {
                staticClass:
                  "d-sm-flex align-items-center justify-content-between"
              },
              [
                _c("div", [
                  _c("nav", { attrs: { "aria-label": "breadcrumb" } }, [
                    _c(
                      "ol",
                      { staticClass: "breadcrumb breadcrumb-style1 mg-b-10" },
                      [
                        _c("li", { staticClass: "breadcrumb-item" }, [
                          _vm._v(_vm._s(this.mainName))
                        ]),
                        _vm._v(" "),
                        _c(
                          "li",
                          {
                            staticClass: "breadcrumb-item",
                            attrs: { "aria-current": "page" }
                          },
                          [_vm._v(_vm._s(this.subName))]
                        ),
                        _vm._v(" "),
                        _c(
                          "li",
                          {
                            staticClass: "breadcrumb-item active",
                            attrs: { "aria-current": "page" }
                          },
                          [_vm._v("Detail")]
                        )
                      ]
                    ),
                    _vm._v(" "),
                    _c("h4", { staticClass: "mg-b-0 tx-spacing--1" }, [
                      _vm._v(_vm._s(this.subName) + " Detail")
                    ])
                  ])
                ]),
                _vm._v(" "),
                _c(
                  "div",
                  {
                    staticClass:
                      "card-header2 col-lg-8 col-xl-7 pd-y-15 pd-x-20 d-flex align-items-center justify-content-end"
                  },
                  [
                    _c(
                      "button",
                      {
                        staticClass:
                          "btn btn-sm pd-x-15 btn-primary btn-uppercase mg-l-5-f",
                        on: {
                          click: function($event) {
                            return _vm.createData(true, "create")
                          }
                        }
                      },
                      [
                        _c("feather", {
                          staticClass:
                            "wd-15 hd-15 mg-r-5 valign-middle-f svg_overflow",
                          attrs: { type: "folder" }
                        }),
                        _vm._v("Save")
                      ],
                      1
                    ),
                    _vm._v(" "),
                    _vm.properties.uid
                      ? _c(
                          "button",
                          {
                            staticClass:
                              "btn btn-sm pd-x-15 btn-primary btn-uppercase mg-l-5-f",
                            on: {
                              click: function($event) {
                                return _vm.deleteData()
                              }
                            }
                          },
                          [
                            _c("feather", {
                              staticClass:
                                "wd-15 hd-15 mg-r-5 valign-middle-f svg_overflow",
                              attrs: { type: "delete" }
                            }),
                            _vm._v("delete")
                          ],
                          1
                        )
                      : _vm._e(),
                    _vm._v(" "),
                    _c(
                      "button",
                      {
                        staticClass:
                          "btn btn-sm pd-x-15 btn-primary btn-uppercase mg-l-5-f",
                        on: {
                          click: function($event) {
                            return _vm.csvExport()
                          }
                        }
                      },
                      [
                        _c("feather", {
                          staticClass:
                            "wd-15 hd-15 mg-r-5 valign-middle-f svg_overflow",
                          attrs: { type: "file" }
                        }),
                        _vm._v("EXCEL")
                      ],
                      1
                    ),
                    _vm._v(" "),
                    _c(
                      "button",
                      {
                        staticClass:
                          "btn btn-sm pd-x-15 btn-primary btn-uppercase mg-l-5-f",
                        on: {
                          click: function($event) {
                            return _vm.goPage()
                          }
                        }
                      },
                      [
                        _c("feather", {
                          staticClass:
                            "wd-15 hd-15 mg-r-5 valign-middle-f svg_overflow",
                          attrs: { type: "file" }
                        }),
                        _vm._v("List")
                      ],
                      1
                    )
                  ]
                )
              ]
            ),
            _vm._v(" "),
            _c("div", { staticClass: " pd-x-0 pd-lg-x-10 pd-xl-x-0" }, [
              _c("div", { staticClass: "col-sm-6 col-lg-5 d-inline-block" }, [
                _c(
                  "ul",
                  {
                    staticClass: "cardborder nav nav-tabs",
                    attrs: { id: "myTab", role: "tablist" }
                  },
                  [
                    _c("li", { staticClass: "nav-item" }, [
                      _c(
                        "a",
                        {
                          staticClass: "nav-link active",
                          attrs: {
                            id: "plating-tab",
                            "data-toggle": "tab",
                            href: "#plating",
                            role: "tab",
                            "aria-controls": "plating",
                            "aria-selected": "true"
                          },
                          on: { click: this.rendertab }
                        },
                        [_vm._v("Result")]
                      )
                    ])
                  ]
                )
              ]),
              _vm._v(" "),
              _c("div", { staticClass: "card card-body pd-b-0-f" }, [
                _c(
                  "div",
                  { staticClass: "tab-content", attrs: { id: "myTabContent" } },
                  [
                    _c(
                      "div",
                      {
                        staticClass: "tab-pane fade lm-overflow show active",
                        attrs: {
                          id: "plating",
                          role: "tabpanel",
                          "aria-labelledby": "plating-tab"
                        }
                      },
                      [
                        _c(
                          "div",
                          {
                            staticClass:
                              "d-none d-md-block tx-right-f mg-xs-y-15-f"
                          },
                          [
                            _c(
                              "a",
                              {
                                staticClass:
                                  "btn btn-xs pd-x-15 btn-secondary btn-uppercase mg-l-5 is-pulled-left",
                                attrs: {
                                  href: "",
                                  "data-toggle": "modal",
                                  "data-animation": "effect-flip-horizontal"
                                },
                                on: { click: this.checkAll }
                              },
                              [
                                _c("feather", {
                                  staticClass:
                                    "wd-15 hd-15 mg-r-5 valign-middle-f svg_overflow",
                                  attrs: { type: "check" }
                                }),
                                _vm._v("all checked")
                              ],
                              1
                            ),
                            _vm._v(" "),
                            this.subName === "IncroB"
                              ? _c(
                                  "a",
                                  {
                                    staticClass:
                                      "btn btn-xs pd-x-15 btn-secondary btn-uppercase mg-l-5",
                                    attrs: {
                                      href: "",
                                      "data-toggle": "modal",
                                      "data-animation": "effect-flip-horizontal"
                                    },
                                    on: {
                                      click: function($event) {
                                        return _vm.dialogHandler("confirm")
                                      }
                                    }
                                  },
                                  [
                                    _c("feather", {
                                      staticClass:
                                        "wd-15 hd-15 mg-r-5 valign-middle-f svg_overflow",
                                      attrs: { type: "file-text" }
                                    }),
                                    _vm._v("confirm")
                                  ],
                                  1
                                )
                              : _vm._e(),
                            _vm._v(" "),
                            _c(
                              "a",
                              {
                                staticClass:
                                  "btn btn-xs pd-x-15 btn-secondary btn-uppercase mg-l-5",
                                attrs: {
                                  href: "",
                                  "data-toggle": "modal",
                                  "data-animation": "effect-flip-horizontal"
                                },
                                on: {
                                  click: function($event) {
                                    return _vm.dialogHandler("report")
                                  }
                                }
                              },
                              [
                                _c("feather", {
                                  staticClass:
                                    "wd-15 hd-15 mg-r-5 valign-middle-f svg_overflow",
                                  attrs: { type: "file-text" }
                                }),
                                _vm._v("report")
                              ],
                              1
                            ),
                            _vm._v(" "),
                            _c(
                              "a",
                              {
                                staticClass:
                                  "btn btn-xs pd-x-15 btn-secondary btn-uppercase mg-l-5",
                                attrs: {
                                  href: "",
                                  "data-toggle": "modal",
                                  "data-animation": "effect-flip-horizontal"
                                },
                                on: { click: this.sampleDelColumn }
                              },
                              [
                                _c("feather", {
                                  staticClass:
                                    "wd-15 hd-15 mg-r-5 valign-middle-f svg_overflow",
                                  attrs: { type: "minus" }
                                }),
                                _vm._v("delete")
                              ],
                              1
                            )
                          ]
                        ),
                        _vm._v(" "),
                        _c(
                          "ul",
                          {
                            staticClass: "nav nav-line",
                            attrs: { id: "myTab5", role: "tablist" }
                          },
                          _vm._l(_vm.tabHeader, function(form, i) {
                            return _vm.properties.mid === form.id
                              ? _c("li", { staticClass: "nav-item" }, [
                                  _c(
                                    "a",
                                    {
                                      staticClass: "nav-link active",
                                      attrs: {
                                        id: form.id,
                                        "data-toggle": "tab",
                                        href: "#",
                                        role: "tab",
                                        "aria-controls": "home",
                                        "aria-selected": "true"
                                      },
                                      on: { click: _vm.classifySampleHeader }
                                    },
                                    [_vm._v(_vm._s(form.menuName))]
                                  )
                                ])
                              : _c("li", { staticClass: "nav-item" }, [
                                  _c(
                                    "a",
                                    {
                                      staticClass: "nav-link",
                                      attrs: {
                                        id: form.id,
                                        "data-toggle": "tab",
                                        href: "#",
                                        role: "tab",
                                        "aria-controls": "profile",
                                        "aria-selected": "false"
                                      },
                                      on: { click: _vm.classifySampleHeader }
                                    },
                                    [_vm._v(_vm._s(form.menuName))]
                                  )
                                ])
                          }),
                          0
                        ),
                        _vm._v(" "),
                        _c("hot-table", {
                          ref: "sheet",
                          staticClass: "ht-hot-table zero-index",
                          attrs: {
                            id: "sample-table",
                            settings: _vm.sheetSettings,
                            data: _vm.sampleData,
                            afterChange: _vm.changeData
                          }
                        })
                      ],
                      1
                    )
                  ]
                )
              ])
            ])
          ])
        ]
      ),
      _vm._v(" "),
      _c(
        "div",
        {
          staticClass: "modal fade",
          attrs: {
            id: "modal5",
            tabindex: "-1",
            role: "dialog",
            "aria-labelledby": "exampleModalLabel5",
            "aria-hidden": "true"
          }
        },
        [
          _c(
            "div",
            {
              staticClass: "modal-dialog modal-dialog-centered chat-width",
              attrs: { role: "document" }
            },
            [
              _c("div", { staticClass: "modal-content tx-14 chat-height" }, [
                _vm._m(0),
                _vm._v(" "),
                _c("div", { staticClass: "modal-body" }, [_c("Chat")], 1)
              ])
            ]
          )
        ]
      ),
      _vm._v(" "),
      _c("v-app", { attrs: { id: "inspire" } }, [
        _c(
          "div",
          [
            _c(
              "v-row",
              { attrs: { justify: "center" } },
              [
                _c(
                  "v-dialog",
                  {
                    staticStyle: { "z-index": "20001" },
                    attrs: { "max-width": "500px", scrollable: "" },
                    model: {
                      value: _vm.reportDialog,
                      callback: function($$v) {
                        _vm.reportDialog = $$v
                      },
                      expression: "reportDialog"
                    }
                  },
                  [
                    _c(
                      "v-card",
                      [
                        _c("v-card-title", [
                          _vm._v(
                            "\n                            Download Report\n                            "
                          )
                        ]),
                        _vm._v(" "),
                        _c(
                          "v-card-text",
                          { staticStyle: { "max-height": "300px" } },
                          _vm._l(_vm.sampleData, function(item, index) {
                            return item[0]
                              ? _c("li", [
                                  _vm._v(_vm._s(item[_vm.sampleNoIdx]))
                                ])
                              : _vm._e()
                          }),
                          0
                        ),
                        _vm._v(" "),
                        _c(
                          "v-card-actions",
                          [
                            _c(
                              "v-btn",
                              {
                                attrs: { color: "primary", text: "" },
                                on: {
                                  click: function($event) {
                                    _vm.reportDialog = false
                                  }
                                }
                              },
                              [
                                _vm._v(
                                  "\n                                Close\n                            "
                                )
                              ]
                            ),
                            _vm._v(" "),
                            _c(
                              "v-btn",
                              {
                                attrs: { color: "primary", text: "" },
                                on: {
                                  click: function($event) {
                                    return _vm.createReport()
                                  }
                                }
                              },
                              [
                                _vm._v(
                                  "\n                                Load\n                            "
                                )
                              ]
                            )
                          ],
                          1
                        )
                      ],
                      1
                    )
                  ],
                  1
                )
              ],
              1
            )
          ],
          1
        )
      ])
    ],
    1
  )
}
var staticRenderFns = [
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "modal-header" }, [
      _c(
        "h6",
        { staticClass: "modal-title", attrs: { id: "exampleModalLabel5" } },
        [_vm._v("Chat")]
      ),
      _vm._v(" "),
      _c(
        "button",
        {
          staticClass: "close",
          attrs: {
            type: "button",
            "data-dismiss": "modal",
            "aria-label": "Close"
          }
        },
        [_c("span", { attrs: { "aria-hidden": "true" } }, [_vm._v("×")])]
      )
    ])
  }
]
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-045d97bd", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-045d97bd","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/views/Result/DetailForm.vue
// module id = null
// module chunks = 